/* eslint-disable */
import { apiWPRequest } from '@/calls/helpers';

const getBanner = async () => {
  try {
    const request = await apiWPRequest('wp-json/acf/v2/options/bandeau_data');
    const banner = request.bandeau_data;

    const data = {
        title: banner.title,
        picture: banner.image.sizes.large,
        start: banner.duration.date_from,
        end: banner.duration.date_to,
        link: banner.link
    };

    return {
      success: true,
      data
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

export {
  // eslint-disable-next-line
  getBanner
};
